var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1450_1922)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8093 34.5943H3.19096C1.43121 34.5943 0 33.1628 0 31.403V3.29958C0 1.53982 1.43094 0.108887 3.19096 0.108887H43.8093C45.5691 0.108887 47.0003 1.53982 47.0003 3.29958V31.403C47.0003 33.1628 45.5693 34.5943 43.8093 34.5943ZM25.6855 30.8046H21.3145C20.5998 30.8046 20.5998 29.7187 21.3145 29.7187H25.6855C26.4002 29.7187 26.4002 30.8046 25.6855 30.8046ZM1.99081 26.3829H45.0092V3.29958C45.0092 2.63808 44.4708 2.09942 43.8093 2.09942H3.19096C2.52947 2.09942 1.99081 2.63808 1.99081 3.29958V26.3829Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6628 41.1273H14.3446C14.0147 41.1273 13.7596 40.8335 13.8076 40.506L14.8282 33.5207C14.8675 33.2539 15.0958 33.0562 15.3655 33.0562H19.2488C19.1807 33.2239 19.1433 33.407 19.1433 33.5992V37.5236C19.1433 38.3225 19.7921 38.9713 20.591 38.9713H26.4095C27.2087 38.9713 27.8572 38.3225 27.8572 37.5236V33.5992C27.8572 33.4073 27.8198 33.2241 27.7517 33.0564H31.6348C31.9044 33.0564 32.1327 33.2539 32.1718 33.521L33.2056 40.5845C33.2056 40.8842 32.963 41.1273 32.6628 41.1273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1945 46.8909H11.8052C10.2953 46.8909 9.06702 45.6621 9.06702 44.1521V42.7796C9.06702 41.2696 10.2953 40.0408 11.8052 40.0408L35.1943 40.0405C36.7042 40.0405 37.9328 41.2693 37.9328 42.7793V44.1519C37.9328 45.6624 36.704 46.8906 35.1945 46.8906V46.8909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4095 38.0661H20.591C20.2914 38.0661 20.0482 37.8226 20.0482 37.5233V33.599C20.0482 33.2993 20.2914 33.0562 20.591 33.0562H26.4095C26.7091 33.0562 26.9523 33.2996 26.9523 33.599V37.5233C26.9523 37.8229 26.7091 38.0661 26.4095 38.0661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4384 13.0696H16.3894C16.0898 13.0696 15.8463 12.8264 15.8463 12.5265V8.38487C15.8463 8.08524 16.0895 7.8418 16.3894 7.8418H22.4384C22.738 7.8418 22.9812 8.08497 22.9812 8.38487V12.5265C22.9812 12.8264 22.738 13.0696 22.4384 13.0696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8741 9.92245H27.3353C26.0245 9.92245 26.0248 7.93164 27.3353 7.93164H40.8741C42.1847 7.93164 42.185 9.92245 40.8741 9.92245ZM40.8741 12.9796H29.0637C27.7528 12.9796 27.7531 10.9888 29.0637 10.9888H40.8741C42.1847 10.9888 42.185 12.9796 40.8741 12.9796ZM40.8741 17.8116H27.3353C26.0245 17.8116 26.0248 15.8211 27.3353 15.8211H40.8741C42.1847 15.8211 42.185 17.8116 40.8741 17.8116ZM40.8741 20.8684H29.0637C27.7528 20.8684 27.7531 18.8779 29.0637 18.8779H40.8741C42.1847 18.8779 42.185 20.8684 40.8741 20.8684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4384 20.9584H16.3894C16.0898 20.9584 15.8463 20.7153 15.8463 20.4156V16.2738C15.8463 15.9741 16.0895 15.731 16.3894 15.731H22.4384C22.738 15.731 22.9812 15.9741 22.9812 16.2738V20.4154C22.9812 20.7158 22.738 20.9584 22.4384 20.9584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.07871 21.3572C5.89832 21.3572 5.73061 21.2685 5.62927 21.1196L3.60459 18.1382C3.43577 17.89 3.50076 17.5521 3.74862 17.3841L6.54494 15.485C6.04759 14.753 5.42272 14.1196 5.67884 13.6697C5.78128 13.4898 5.97764 13.386 6.18391 13.3962L12.4615 13.7815C12.8159 13.8029 13.0544 14.1549 12.9439 14.4923L10.9876 20.4696C10.8479 20.8962 10.2762 20.9797 10.0223 20.6059L9.17879 19.3645C8.72908 19.6699 6.42598 21.3569 6.07843 21.3569L6.07871 21.3572Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1450_1922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout4);
export default __webpack_public_path__ + "static/media/about-4.6ef518d6f2be88612c0f1e24da4f8dfb.svg";
export { ForwardRef as ReactComponent };